import { AttributesMixin, define, Model } from '@type-r/models';
import { fetchAndResolve } from '.';
import { ReviewApprovedInvoicesState } from '../invoices/review/approved-invoices';
import { ReviewSentOutInvoicesState } from '../invoices/review/sent-out-invoices';
import { ReviewSentOutSoaState } from '../invoices/review/sent-out-soa';
import { BrokenPromiseInvoicesState } from '../invoices/todo/broken-promise';
import { DisputedInvoicesState } from '../invoices/todo/disputed';
import { NotSentState } from '../invoices/todo/not-sent';
import { OverdueState } from '../invoices/todo/overdue';
import { ItemsNotSentState } from '../invoices/todo/soa-not-sent';
import { UpcommingInvoicesState } from '../invoices/todo/upcoming';

@define
export class InvoiceLandingSummary extends Model {

    static attributes = {
        // todo widgets
        overDue: OverdueState,
        notSent: NotSentState,
        itemsNotSent: ItemsNotSentState,
        disputedInvoices: DisputedInvoicesState,
        brokenPromiseInvoices: BrokenPromiseInvoicesState,
        upcommingInvoices: UpcommingInvoicesState,
        // review widgets
        approvedInvoices: ReviewApprovedInvoicesState,
        sentOutInvoices: ReviewSentOutInvoicesState,
        sentOutSoa: ReviewSentOutSoaState
    };

    async fetch() {

        Promise.all([
            fetchAndResolve(this.overDue),
            fetchAndResolve(this.notSent),
            fetchAndResolve(this.itemsNotSent),
            fetchAndResolve(this.disputedInvoices),
            fetchAndResolve(this.brokenPromiseInvoices),
            fetchAndResolve(this.upcommingInvoices),
        ]);

        Promise.all([
            fetchAndResolve(this.approvedInvoices),
            fetchAndResolve(this.sentOutInvoices),
            fetchAndResolve(this.sentOutSoa)
        ]);

        return this;
    }

    get isTodoReady() {
        return this.overDue.isReady &&
            this.notSent.isReady &&
            this.itemsNotSent.isReady &&
            this.disputedInvoices.isReady &&
            this.brokenPromiseInvoices.isReady &&
            this.upcommingInvoices.isReady;
    }

    get isReviewReady() {
        return this.approvedInvoices.isReady &&
            this.sentOutInvoices.isReady &&
            this.sentOutSoa.isReady;
    }

    get getCount() {
        return this.todoCount;
    }

    get todoCount() {
        return this.overDue.getCount()
            + this.notSent.getCount()
            + this.itemsNotSent.getCount()
            + this.disputedInvoices.getCount()
            + this.brokenPromiseInvoices.getCount()
            + this.upcommingInvoices.getCount();
    }

    get reviewCount() {
        return this.approvedInvoices.getCount()
            + this.sentOutInvoices.getCount()
            + this.sentOutSoa.getCount();
    }
}
export interface InvoiceLandingSummary extends AttributesMixin<typeof InvoiceLandingSummary> { }
